import { getAllCookies, removeCookie } from 'app/adapters/cookies';
import { removeStorageItems } from 'app/adapters/storage';
import { LogoutEndpointService } from 'app/services/api/LogoutEndpointService';
import { FLEET_EMBED_STORAGE_KEY } from 'app/utils/fleet-embed';
import { removeVtOnBehalfOfCookie } from 'app/utils/vt-on-behalf-of';

export function removeAllCookies(
  allCookies: {
    [key: string]: string;
  },
  cb: (name: string) => void,
) {
  Object.keys(allCookies).forEach(cookieName => void cb(cookieName));
}

/**
 * Clear session variables like `localStorage` and `cookies` data.
 */
export function clearSession() {
  removeCookie('JSESSIONID');
  removeAllCookies(getAllCookies(), removeCookie);
  // CanJS-style attrs (no Domain) — adapter remove may miss this cookie.
  removeVtOnBehalfOfCookie();
  removeStorageItems(['token', 'isAuthUser', 'xClientIdentifier']);
  window.sessionStorage.removeItem('authToken');
  window.sessionStorage.removeItem(FLEET_EMBED_STORAGE_KEY);
}

/**
 * Ends any existing server session and clears local auth state before a new login.
 * Without this, loginEndpoint can return 204 while myUser still reflects the prior user.
 */
export async function prepareLoginSession() {
  try {
    await LogoutEndpointService.clearUserSession();
  } catch {
    // No active session to clear; continue with local cleanup.
  }

  clearSession();
}
